import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './components/ModalMobile.css';
import './components/MobileOptimized.css';

// Context
import { CarrinhoProvider } from './services/CarrinhoContext';

// Utils
import { initCampaignContext } from './utils/campaignContext';

// Pages
import Cardapio from './pages/Cardapio';
import Mesa from './pages/Mesa';
import TabletTokenDaMesa from './pages/TabletTokenDaMesa';
import WhatsAppLogin from './pages/WhatsAppLogin';
import Loja from './pages/Loja';
import QRScanner from './pages/QRScanner';
import PedidoDetalhes from './pages/PedidoDetalhes';
import AuthSuccess from './pages/AuthSuccess';
import Videos from './pages/Videos';
import Reserva from './pages/Reserva';
import FilaAtendimento from './pages/FilaAtendimento';
import FeedbackPage from './pages/FeedbackPage';
import NotFound from './pages/NotFound';

// Components
import PedidoVinculadoToast from './components/PedidoVinculadoToast';

// Google OAuth Client ID
const GOOGLE_CLIENT_ID = "769772028574-ko4tmv56kvotqhcrbe3f7tai2a5iqju3.apps.googleusercontent.com";

// Função para extrair brand do subdomínio
const getBrandFromSubdomain = () => {
  const host = window.location.host;
  const parts = host.split('.');
  return parts[0].includes('localhost') ? 'gente-bonita' : parts[0];
};

function App() {
  const [brand, setBrand] = useState(null);

  useEffect(() => {
    const brandFromSubdomain = getBrandFromSubdomain();
    setBrand(brandFromSubdomain);
  }, []);

  // Inicializar contexto de campanha de marketing (captura param da URL)
  useEffect(() => {
    initCampaignContext();
  }, []);

  // Verificar e vincular pedidos anônimos ao fazer login
  useEffect(() => {
    const verificarPedidoAnonimo = async () => {
      const token = localStorage.getItem('sitri_token');
      if (!token) return;

      try {
        const { obterPedidoAnonimo, limparPedidoAnonimo } = await import('./services/pedidoAnonimo');
        const { vincularPedidoAnonimo } = await import('./services/api');
        const pedidoAnonimo = obterPedidoAnonimo();
        
        if (pedidoAnonimo && pedidoAnonimo.comandaId) {
          
          try {
            await vincularPedidoAnonimo(token, {
              comandaId: pedidoAnonimo.comandaId,
              brand: pedidoAnonimo.brand
            });
            
            // Disparar evento customizado para mostrar toast
            window.dispatchEvent(new CustomEvent('pedidoVinculado', {
              detail: pedidoAnonimo
            }));
            
            limparPedidoAnonimo();
          } catch (error) {
          }
        }
      } catch (error) {
      }
    };

    verificarPedidoAnonimo();
  }, []);

  if (!brand) {
    return <div>Carregando...</div>;
  }

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <CarrinhoProvider brand={brand}>
        <Router>
          <div className="App">
            <PedidoVinculadoToast />
            <Routes>
              {/* Rota raiz - loja completa */}
              <Route path="/" element={<Loja brand={brand} />} />
              
              {/* Rota para cardápio somente visualização */}
              <Route path="/cardapio" element={<Cardapio brand={brand} />} />
              
              {/* Rota para produto específico */}
              <Route path="/produto/:produtoId" element={<Cardapio brand={brand} />} />
              
              {/* Rota para dinein com token */}
              <Route path="/dinein/:token" element={<Mesa brand={brand} />} />
              
              {/* Rota para vídeos em dinein */}
              <Route path="/dinein/:token/videos" element={<Videos brand={brand} />} />
              
              {/* Rota para tablet com token da mesa (entra como balcão) */}
              <Route path="/tablet/tokendamesa/:token" element={<TabletTokenDaMesa brand={brand} />} />
              
              {/* Rota para tablet com token */}
              <Route path="/tablet/:token" element={<TabletTokenDaMesa brand={brand} />} />
              
              {/* Rota para vídeos em tablet */}
              <Route path="/tablet/:token/videos" element={<Videos brand={brand} />} />
              
              {/* Rota para delivery */}
              <Route path="/delivery" element={<Cardapio brand={brand} delivery={true} />} />
              
              {/* Rota para produto em delivery */}
              <Route path="/delivery/produto/:produtoId" element={<Cardapio brand={brand} delivery={true} />} />
              
              {/* Rota para delivery com hash (WhatsApp) */}
              <Route path="/delivery/:hash" element={<Cardapio brand={brand} delivery={true} />} />
              
              {/* Rota para balcão */}
              <Route path="/balcao" element={<Cardapio brand={brand} balcao={true} />} />
              
              {/* Rota para produto em balcão */}
              <Route path="/balcao/produto/:produtoId" element={<Cardapio brand={brand} balcao={true} />} />
              
              {/* Rota para acompanhar comanda por hash */}
              <Route path="/comanda/:hash" element={<Cardapio brand={brand} delivery={true} />} />
              
              {/* Rota para detalhes do pedido por hash */}
              <Route path="/pedido/:hash" element={<PedidoDetalhes brand={brand} />} />
              
              {/* Rota para login WhatsApp */}
              <Route path="/w/:token" element={<WhatsAppLogin />} />
              
              {/* Rota para vídeos */}
              <Route path="/videos" element={<Videos brand={brand} />} />
              
              {/* Rota para vídeos em delivery */}
              <Route path="/delivery/videos" element={<Videos brand={brand} delivery={true} />} />
              
              {/* Rota para vídeos em balcão */}
              <Route path="/balcao/videos" element={<Videos brand={brand} balcao={true} />} />
              
              {/* Rota para reserva de mesa */}
              <Route path="/reserva" element={<Reserva brand={brand} />} />
              
              {/* Rota para fila de atendimento */}
              <Route path="/fila" element={<FilaAtendimento brand={brand} />} />
              <Route path="/fila/:hash" element={<FilaAtendimento brand={brand} />} />
              
              {/* Rota para feedback de atendimento */}
              <Route path="/feedback/:token" element={<FeedbackPage brand={brand} />} />
              
              {/* Redirect de /loja e /home para / (compatibilidade com links antigos) */}
              <Route path="/loja" element={<Navigate to="/" replace />} />
              <Route path="/home" element={<Navigate to="/" replace />} />
              
              {/* Rota para scanner de QR code */}
              <Route path="/qr-scanner" element={<QRScanner brand={brand} />} />
              
              {/* Rota para retorno do OAuth */}
              <Route path="/auth/success" element={<AuthSuccess />} />
              <Route path="/auth/google/callback" element={<AuthSuccess />} />
              
              {/* Rota 404 - deve ser a última */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </Router>
      </CarrinhoProvider>
    </GoogleOAuthProvider>
  );
}

export default App;